import { SettingOutlined } from "@ant-design/icons";
import React, { useState, useEffect, useRef } from "react";
import { ConfigProvider, Pagination } from 'antd';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import viVN from 'antd/locale/vi_VN';
import "../styles.scss";
import MegaTable from "../../../components/MagaTableV2";
import { formatNumber, mixGetV2 } from '../../../services/mixin';
import { dataPagination } from '../../../until';
import { SHOW_KEYNAME } from '../../../env';
import { Dashboard } from "../../../components/ExportImgFigma";
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';

const VehicleInformationyTabs = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const user = useSelector(selectorInfoUser);
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.ownership_type_detail?.list.map((col: any) => {
      if (col.field === 'present_mile_age' || col.field === 'total_amount' || col.field === 'repair_amount' || col.field === 'item_amount' || col.field === 'invoice_service_total_amount') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
          valueFormatter: (params: any) => formatNumber(params.value)
        })
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheMaintenanceHistory',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: "vehicle_name", headerName: "Tên xe" },
      // { field: "cus_name", headerName: "Chủ sở hữu" },
      // { field: "customer_interactions_box_code", headerName: "Thùng" },
      // { field: "chassis_no", headerName: "Số khung (VIN)" },
      // { field: "number_plate", headerName: "Biển số xe" },
      // { field: "vehicle_brand", headerName: "Thương hiệu" },
      // { field: "color_name", headerName: "Màu xe" },
      // { field: "branch_name", headerName: "Đơn vị dùng dịch vụ" },
      // {
      //   field: "vehicle_model", headerName: "Dòng xe", cellRenderer: (params: any) => {
      //     if (params.data.vehicle_model === 'TB') {
      //       return 'Tải Bus'
      //     } else if (params.data.vehicle_model === 'DL') {
      //       return 'Du lịch'
      //     } else {
      //       return params.data.vehicle_model
      //     }
      //   }
      // },
      // { field: "engine_no", headerName: "Số máy" },
      // { field: "engine_type", headerName: "Loại động cơ" },
      // { field: "made_year", headerName: "Năm sản xuất" },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
  });

  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const vehicleIdRef = useRef<any>(null);

  const getDetail = async (id: any, page = 1, limit = 10) => {
    setLoading(true);
    const res = await mixGetV2(`/api/v1/be/customer/vehicle_service_history?id_sync=${stData.cus_id}&id_vehicle=${id}&page=${page}&limit=${limit}&admin_id=${user.id}`);
    if (res.data) {
      stChange({
        list: res.data,
        summary: res.summary
      }, 'vehicle_service_history');
      setPagination(prev => ({ ...prev, current: page, pageSize: limit, total: res.pagination.total || 0 }));
      setLoading(false);
    }
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    getDetail(vehicleIdRef.current, pageNumber, pageSize);
  };

  useEffect(() => {
    if (stData.xesudung_show && stData.xesudung_show.id) {
      vehicleIdRef.current = stData.xesudung_show.id;
      getDetail(stData.xesudung_show.id, 1, pagination.pageSize);
    }
  }, [stData.xesudung_show]);

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>

      <div className="custom-page-css w-full flex gap-3 mb-3">
        <div className="custom-page-css  flex flex-1 flex-column rounded border mw-50 ">
          <div className="custom-page-css w-full flex items-center gap-4 p-3 border-b">
            <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full w-1/3">
              <img
                src={Dashboard}
                alt=""
                style={{ height: 16, width: 16, objectFit: "contain" }}
              />
            </div>
            <span className="custom-page-css text-xl font-light text-475467">
              Tổng quan
            </span>
          </div>
          <div className="custom-page-css flex py-2">
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054" {...(SHOW_KEYNAME === true && { 'col-id': 'xesudung_show_vehicle_service_history.summary.total_service_count' })}>
                {stData.xesudung_show_vehicle_service_history && stData.xesudung_show_vehicle_service_history.summary ? stData.xesudung_show_vehicle_service_history.summary.total_service_count : 0}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Số lần BD
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054" {...(SHOW_KEYNAME === true && { 'col-id': 'xesudung_show_vehicle_service_history.summary.total_amount' })}>
                {formatNumber(stData.xesudung_show_vehicle_service_history && stData.xesudung_show_vehicle_service_history.summary ? stData.xesudung_show_vehicle_service_history.summary.total_amount : 0)}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Tổng tiền
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054" {...(SHOW_KEYNAME === true && { 'col-id': 'xesudung_show_vehicle_service_history.summary.latest_service_date' })}>
                {stData.xesudung_show_vehicle_service_history && stData.xesudung_show_vehicle_service_history.summary ? stData.xesudung_show_vehicle_service_history.summary.latest_service_date : 'Không xác định'}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Ngày BD gần nhất
              </span>
            </div>
          </div>
        </div>
      </div>
      <MegaTable
        stData={{ ...megaTableData, listData: stData.xesudung_show_vehicle_service_history && stData.xesudung_show_vehicle_service_history.list ? stData.xesudung_show_vehicle_service_history.list : [], loading: loading }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
      <ConfigProvider locale={viVN}>
        <div className="pagination-block">
          <Pagination
            showSizeChanger
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            showTotal={() => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
            className='rs-pagination'
            onChange={onPaginationChange}
          />
        </div>
      </ConfigProvider>
    </>
  );
};
export default VehicleInformationyTabs;
